"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function measureTime(timeMark) {
    if (typeof window === 'undefined' || typeof performance === 'undefined') {
        return -1;
    }
    var timing = performance.timing;
    var offset = timing.domInteractive - timing.navigationStart;
    var mark = +(performance.now() - offset).toFixed(2);
    if (window.__app.timings && window.__app.timings[timeMark] === undefined) {
        window.__app.timings[timeMark] = mark;
    }
    return mark;
}
exports.default = measureTime;
//# sourceMappingURL=measureTime.js.map